import { TFunction } from 'i18next';

export function leaveStatusText(status: string, t: TFunction) {
  switch (status) {
    case 'CHECKED':
      return <span className="text-green-600">{t('common:labels.status-accepted')}</span>;
    case 'NOT_CHECKED':
      return <span className="text-blue-400">{t('common:labels.status-in-progress')}</span>;
    case 'CANCEL_BY_OWNER':
      return <span className="text-dormitory">{t('common:labels.status-canceled')}</span>;
    default:
      return <span className="text-orange-400">{t('common:labels.unknown')}</span>;
  }
}

export function dormitoryInviteStatus(status: DormitoryMemberStatus, t: TFunction) {
  switch (status) {
    case 'APPROVED':
      return <span className="text-green-600">{t('common:labels.status-accepted')}</span>;
    case 'FINAL':
      return <span className="text-green-600">{t('common:labels.status-final')}</span>;
    case 'WAITING':
      return <span className="text-blue-400">{t('common:labels.status-wait-for-accept')}</span>;
    default:
      return <span>{t('common:labels.unknown')}</span>;
  }
}

export function dormitorySolitaryStatus(status: DormitoryMemberStatus, t: TFunction) {
  switch (status) {
    case 'APPROVED':
      return <span className="text-orange-400">{t('common:labels.status-in-progress')}</span>;
    case 'FINAL':
      return <span className="text-green-600">{t('common:labels.status-final')}</span>;
    case 'WAITING':
      return <span className="text-blue-400">{t('common:labels.status-wait-for-accept')}</span>;
    default:
      return <span>{t('common:labels.unknown')}</span>;
  }
}

export function dormitoryRequestStatusText(status: string, t: TFunction) {
  switch (status) {
    case 'WAITING':
      return t('common:labels.suspend');
    case 'ACCEPT':
    case 'APPROVED':
      return t('common:labels.status-accepted');
    case 'REJECTED':
    case 'REJECT':
      return t('common:labels.status-rejected');
    case 'TRANSFER':
      return t('common:labels.status-transfer');
    default:
      return t('common:labels.status-non-checked');
  }
}
